<template>
  <div
    class="go_top"
    id="go"
    @click="goTop()"
  >
  </div>
</template>

<script>
import { goTop } from './js/goTop'
export default {
  methods: {
    goTop() {
      goTop()
    },
  },
  mounted() {
    var go = document.getElementById('go')
    var clientHeight = document.documentElement.clientHeight // 获取页面可视区域的高度
    var timer = null // 存放定时器
    var isTop = true
    // 滚动条滚动时触发
    window.onscroll = function () {
      var osTop = document.documentElement.scrollTop || document.body.scrollTop
      if (osTop >= clientHeight) {
        go.style.display = 'block'
      } else {
        go.style.display = 'none'
      }
      if (!isTop) {
        clearInterval(timer)
      }
      isTop = false
    }
  },
}
</script>

<style lang='sass'>
.go_top
  width: 54px
  height: 54px
  position: fixed
  right: 10px
  bottom: 20px
  z-index: 989898
  background: url(./images/topback.png) no-repeat
  cursor: pointer
  display: none
</style>



// WEBPACK FOOTER //
// src/components/goTop/goTop.vue